import * as actions from "./actions";
// import * as generic from "@/store/generic/mutations/result-status.js";

const state = {};

const getters = {};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
  